import Alpine from 'alpinejs'

Alpine.data('popup', (id) => {
  return {
    id: id,
    isOpen: false,

    init () {
      window.addEventListener('hashchange', this.checkHash.bind(this))
      window.addEventListener('popstate', this.checkHash.bind(this))
      this.checkHash()
    },

    checkHash () {
      if (window.location.hash.replace('#', '') === id) {
        this.open()
      }
    },

    open () {
      this.isOpen = true
    },

    close () {
      this.isOpen = false
      let targetUrl = new URL(window.location)
      targetUrl.hash = ''
      history.replaceState(null, null, targetUrl.href)
    }
  }
})
